(function ($) {


    $(document).on('ready', function () {

        function recenterBox(boxEl) {
            if (!boxEl) return;

            const display = window.getComputedStyle(boxEl).display;
            if (display === 'none') return;


            // applying custom position with delay to wai until boxzilla applies its own code for positioning

            setTimeout(function () {
                // Reset first, then measure fresh height
                boxEl.style.marginTop = '0px';

                const viewportHeight = window.innerHeight;
                const boxHeight = boxEl.offsetHeight;
                const marginTop = Math.max(0, Math.round((viewportHeight - boxHeight) / 2));

                boxEl.style.marginTop = marginTop + 'px';
                boxEl.classList.add('brand-boxzilla-visible');
            }, 1000);
        }

        function recenterAfterShow(box) {
            const boxEl = box && box.element ? box.element : null;
            if (!boxEl) return;

            // One frame may be too early, so do it twice
            requestAnimationFrame(function () {
                recenterBox(boxEl);

                requestAnimationFrame(function () {
                    recenterBox(boxEl);
                });
            });
        }

        if (window.Boxzilla && typeof window.Boxzilla.on === 'function') {
            window.Boxzilla.on('box.show', function (box) {
                if ( !(box && box.element) ) return;

                document.body.classList.add('c-modal-opened');

                recenterAfterShow(box);
            });


            window.Boxzilla.on('box.hide', function (box) {
                if ( !(box && box.element) ) return;

                document.body.classList.remove('c-modal-opened');

                box.element.classList.remove('brand-boxzilla-visible');
            });
        }

        window.addEventListener('resize', function () {
            document.querySelectorAll('.boxzilla.boxzilla-center').forEach(recenterBox);
        });

    });


})(jQuery);